import { customerListProxy } from '../../../../../../../shared/proxies/customerListProxy'
import { buildAxiosInstance } from '../../../../../../../shared/utils/apiUtils'
import { type GlobalCustomerType } from '../../../../../../../shared/types/GlobalCustomerType'

interface Response {
  data: {
    customers: GlobalCustomerType[]
  } | null
  error: string | null
}

export async function executeCustomerSectionCustomersSearch (search = ''): Promise<void> {
  customerListProxy.apiCallCustomerSearch.loading = true
  customerListProxy.apiCallCustomerSearch.error = null
  try {
    const response = await buildAxiosInstance().post<Response>('/api/customers/search', { search })
    if (response.data.data) {
      customerListProxy.customers = response.data.data.customers
    } else {
      customerListProxy.apiCallCustomerSearch.error = response.data.error
    }
  } catch (e) {
    if (e instanceof Error) {
      customerListProxy.apiCallCustomerSearch.error = e.message
    }
  } finally {
    customerListProxy.apiCallCustomerSearch.loading = false
  }
}
